import VideoModal from '../../../react-app-src/videoModal/components/VideoModal';
import VideoUtils from '../../../assets/components/fsUtils/videoUtils';

class VideoModalHandler {
    constructor() {
        VideoUtils.loadVideoPlayer(this.launchVideoModal);
    }

    launchVideoModal(item, isBB, isModal){
        if(!isModal) return;
        let modalCont = document.getElementById('video-player-modal');
        let playerDiv = item.querySelector('.fs-video-player');
        let config = playerDiv.getAttribute('data-player-config');
        let configObj = JSON.parse(config);

        let link = '';
        let category = '';
        let title = '';
        let pubDate = '';
        let url = '';

        if(isBB) {
            title = item.querySelector('wisbb_teamArticleTitle');
            pubDate = item.querySelector('wisbb_teamArticleTimestamp');
            category = item.querySelector('wisbb_teamArticleAuthor');
            url = item.configObj.url;


        } else {
            link = item.querySelector('.trending-item-link');
            if(link) {
                category = link.getAttribute('category');
                title = link.getAttribute('title');
                pubDate = link.getAttribute('pub-date');
                url = link.getAttribute('href');
            }
        }

        modalCont.style = 'display: block';

        //render the modal
        ReactDOM.render(<VideoModal videoConfig={config} category={category} title={title} pubDate={pubDate} videoUrl={url}/>, modalCont);
    }
}

export default new VideoModalHandler()


// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/VideoModalHandler.js